<template>
  <div class="clientTaskInfoContent">
    <div class="top">
      <van-icon size="22px" name="arrow-left" @click="back" />
      <span class="title">{{ $t('append_field.bind_task') }}</span>
    </div>
    <div v-if="clientTaskInfo.length > 0" class="scrollable-content">
      <div class="clientTaskInfoList clientTaskInfoBlock" v-for="(item,index) in clientTaskInfo"
           :key="index">
        <van-cell :title="$t('append_field.task_name')">
          {{ item.name }}
        </van-cell>
        <van-cell :title="$t('append_field.task_type')">
          {{  item.state == '1' ? $t('append_field.pub_task') : $t('append_field.pub_task') }}
        </van-cell>
        <van-cell :title="$t('append_field.playMode')">
          <template v-if="item.type == '1'">
            {{ $t('append_field.replaceMode') }}
          </template>
          <template v-else-if="item.type == '2'">
            {{ $t('append_field.appendMode') }}
          </template>
          <template v-else-if="item.type == '3'">
            {{ $t('append_field.apotpatterns') }}
          </template>
          <template v-else-if="item.type == '7'">
            {{ $t('append_field.plan_mode') }}
          </template>
          <template v-else-if="item.type == '8'">
            {{ $t('append_field.default_mode') }}
          </template>
        </van-cell>
        <van-cell :title="$t('append_field.playback_date')">
          {{ item.startTime.split('~')[0] }} ~ {{ item.endTime.split('~')[0] }}
        </van-cell>
        <van-cell :title="$t('append_field.playback_period')">
          {{ item.startTime.split('~')[1] }} ~ {{ item.endTime.split('~')[1] }}
        </van-cell>
        <van-cell :title="$t('append_field.taskPeriod')">
          <van-button style="float: right" color="#FF5700" size="small" @click="deleteTask(item)">{{$t('append_field.delete')}}</van-button>
        </van-cell>
        <van-cell >
          <div class="cycleList">
            <div class="cycleItem">
              <div class="weekli" :class="item.mon == 'true' ? 'istrue' : ''">{{$t('append_field.mon')}}</div>
              <div class="weekli" :class="item.tue == 'true' ? 'istrue' : ''">{{$t('append_field.tue')}}</div>
              <div class="weekli" :class="item.wed == 'true' ? 'istrue' : ''">{{$t('append_field.wed')}}</div>
              <div class="weekli" :class="item.thur == 'true' ? 'istrue' : ''">{{$t('append_field.thu')}}</div>
              <div class="weekli" :class="item.fri == 'true' ? 'istrue' : ''">{{$t('append_field.fri')}}</div>
              <div class="weekli" :class="item.sat == 'true' ? 'istrue' : ''">{{$t('append_field.sat')}}</div>
              <div class="weekli" :class="item.sun == 'true' ? 'istrue' : ''">{{$t('append_field.sun')}}</div>
            </div>
          </div>
        </van-cell>
      </div>
    </div>
    <div v-else>
      <van-empty
          class="custom-image"
          image="/static/images/terminal/empty-img.png"
          :description="$t('append_field.no_data')"
      />
    </div>
  </div>

</template>
<script>
import qs from "qs";
import {Dialog, Toast} from "vant";

export default {
  data() {
    return {
      clientTaskInfo: [],
      id:1,
      clNo: '',
    }
  },
  mounted() {
    this.id = this.$route.query.id
    this.clNo = this.$route.query.clNo
    const tabbar = document.querySelector('.van-tabbar')
    tabbar.style.display = 'none'
    this.getClientInfo()
    document.title = this.$t('append_field.bind_task')
  },
  methods: {
    getClientInfo() {
      this.$ajax.post('/etv/selectClientCommonTaskByClId.json', qs.stringify({
        id: this.id,
      })).then(res => {
        if (res.data.code === 0) {
          this.clientTaskInfo = res.data.data.taskList
        }
      })

    },
    deleteTask(data) {
      Dialog.confirm({
        title: this.$t('append_field.delete')
        , message: this.$t('append_field.confirm_delete_task'),
      }).then(() => {
        this.$ajax.post('/etv/deleteCommonTaskByClientId.json', qs.stringify({
          id: this.id,
          taskId: data.id
        })).then(res => {
          if (res.data.code === 0) {
            Toast(this.$t('append_field.delete_success'))
            this.getClientInfo()
          } else {
            Toast(res.data.msg)
          }
        })
      }).catch(() => {
      })
    },
    back() {
      this.$router.back()
    }
  }

}
</script>
<style scoped lang="scss">
@import "../../public/static/css/app";
.clientTaskInfoContent {
  height: 100% !important;
  display: flex;
  flex-direction: column;
  .top{
    padding:18px 10px;
    display: flex;
    align-items: center; /* 垂直居中对齐 */
    justify-content: center; /* 水平居中对齐 */
    position: relative; /* 使子元素可以相对于父元素定位 */
    border-bottom: #8c8c8c 1px solid;
    z-index: 10; /* 确保在滚动内容之上 */
    .van-icon {
      position: absolute; /* 绝对定位 */
      left: 10px; /* 根据需要调整左边距 */
    }
    .title{
      font-size: 18px;
      font-size: 18px;
      float: none; /* 确保不使用浮动 */
      display: inline-block; /* 使元素成为行内块级元素 */
    }
  }
  .scrollable-content {
    overflow-y: auto; /* 使内容可垂直滚动 */
    flex-grow: 1; /* 占据剩余空间 */
  }
  .clientTaskInfoBlock {
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    background: #fff;
    font-size:  15px;

    .van-cell__title{
      flex: auto;
    }
    .van-cell__value{
      flex: auto;
    }
    .clientTaskInfoItem {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid $uni-bg-color-title;
      padding: 10px 15px 10px 20px;
      box-sizing: border-box;

      .clientTaskInfo_key {
        width: auto;
        display: flex;
        align-items: center;

        .clientTaskInfo_key_icon {
          height: 10px;
          width: 10px;
          background: #006EFF;
          margin-right: 5px;
        }

      }

      .clientTaskInfo_val {
        color: #969696;
        flex: 1;
        text-align: right;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }


    }

    .clientTaskInfoItem:last-child {
      border-bottom: none;
    }
    .cycleList {
      display: flex;
      width: 100%;

      .cycleItem {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        width: 100%;

        .weekli {
          width: 40px;
          height: 40px;
          align-items: center;
          display: flex;
          justify-content: center;
          line-height:34px;
          background: #fff;
          color: #006EFF;
          border: 1px solid #006EFF;
        }

        .istrue {
          background: #006EFF;
          color: #fff;

        }
      }
    }
    .btnList {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      padding-right: 20px;
      box-sizing: border-box;

      .btn {
        display: flex;
        flex: 0 0 auto;
        height: 27px;
        line-height: 27px;
        background: #006EFF;
        margin: 10px 0 10px 10px;
        width: 50px;
        justify-content: center;
        border-radius: 5px;
        color: #fff;

        &.btn-modify {
        }

        &.btn-send {
        }

        &.btn-delete {
          background: #fff;
          color: red;
          border: 1px solid red;
        }
      }
    }
  }
}
</style>